<!-- Add to or remove a station from the last session -->
<template>
  <div>
    <confirm-dialog @confirm="remove" v-if="state === true">
      <template v-slot:activator="{attr,on}">
        <v-btn
          v-bind="attr"
          v-on="on"
          small
          color="red darken-2"
          dark
        ><v-icon left>mdi-delete-circle</v-icon>Премахни от последната сесия</v-btn>
      </template>
      Сигурни ли сте?<br>
      Това ще премахне данните към последната сесия за всички имоти и уреди в тях
    </confirm-dialog>
    <v-btn
      small
      v-if="state === false"
      @click="add"
      color="primary darken-1"
    ><v-icon left>mdi-plus-circle</v-icon>Добави към последната сесия</v-btn>
  </div>
</template>

<script>
import IModelMixin from "@/ittijs/IModelMixin";
import ConfirmDialog from "@/ittijs/ConfirmDialog";

export default {
  components: {ConfirmDialog},
  mixins: [
    IModelMixin,
  ],
  props: {
    stationId: Number,
  },
  data(){
    return {
      state: null, // can be null, true, or false
    }
  },
  mounted() {
    this.loadState();
  },
  watch: {
    stationId(){
      this.loadState();
    },
  },
  methods: {
    async loadState(){
      this.state = true;
      if (this.stationId > 0) {
        const state = await this.imodel.getLastSessionState(this.stationId);
        if (state === null || typeof state === 'boolean') {
          this.state = state;
        }
        else {
          this.state = null;
        }
      }
    },
    async add(){
      if (this.stationId > 0 && await this.imodel.lastSessionAdd(this.stationId)) {
        this.state = true;
      }
    },
    async remove(){
      if (this.stationId > 0 && await this.imodel.lastSessionRemove(this.stationId)) {
        this.state = false;
      }
    },
  },
}
</script>